import Vue from "vue";

// 全局预览事件总线：让 ProductDetail 和全局 iframe 通信
export default new Vue();
